export const HEADER_ROUTES_CONSTANTS = Object.freeze({
  HOME: '/home',
  NEW_LOAN: '/newLoan',
  HISTORY: '/history',
  PAYMENT_METHODS: '/payment-methods',
  ACCOUNT_BASIC_INFORMATION: '/account/basicAdditionalInformation',
  CREATE_CARD: '/card-explain',
  REFERRALS: '/referrals',
});
